module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "epigraph2"
    }
  }, [_c('i', [_vm._v("quest:")]), _vm._v(" a chivalrous enterprise in medieval romance usually involving an adventurous journey.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("—Webster’s Third New International")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("Dictionary")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3588b944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5-epigraph2.vue
// module id = 75
// module chunks = 0